import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';

import tunnelsReducer from './reducers';

const importTunnels = () => import(/* webpackChunkName: "tunnels" */ './containers/TunnelsContainer');

const TunnelsRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <SentryBoundary owner={sentryConstants.TEAMS.WEB_PLATFORM}>
      <BundleRoute
        load={importTunnels}
        path={match.url}
      />
    </SentryBoundary>
  </LoginRequiredContainer>
);

TunnelsRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default dynamic(
  'apps.tunnels', attachReducer(tunnelsReducer),
)(TunnelsRoutes);
export { TunnelsRoutes };
